import { type ITooltipProps, Switch } from 'shared/ui'
import { AgentCard, type IAgentCardProps } from 'entities/AIAgent/ui/AgentCard/AgentCard.tsx'

type IAgentSwitchFieldProps = {
  active: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
  switchTooltipProps?: ITooltipProps
} & IAgentCardProps

export const AgentSwitchField = ({
  active,
  onChange,
  disabled,
  switchTooltipProps,
  size = 'small',
  ...props
}: IAgentSwitchFieldProps) => {
  return (
    <AgentCard
      rightContent={
        <Switch
          value={active}
          size={size === 'small' ? 'small' : 'middle'}
          onChange={onChange}
          disabled={disabled}
          tooltipProps={switchTooltipProps}
        />
      }
      size={size}
      {...props}
    />
  )
}
